import { Card, Box, Chip, SvgIcon, Container } from '@mui/material'
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar'
import { styled } from '@mui/material/styles'

export const StyledDateCalendar = styled(DateCalendar)(({ theme }) => ({
  '&.MuiDateCalendar-root': {
    height: '300px',
    '.MuiDayCalendar-slideTransition': {
      minHeight: '200px',
    },
    '.MuiDayCalendar-weekContainer > button.MuiPickersDay-root': {
      fontSize: '1rem',
      fontWeight: 'bold',
    },
    '.MuiDayCalendar-header > span.MuiDayCalendar-weekDayLabel': {
      fontSize: '1rem',
      fontWeight: 'bold',
    },
    '.MuiPickersArrowSwitcher-root > button.MuiPickersArrowSwitcher-button > svg':
      {
        fontSize: '1.75rem',
      },
  },
}))

export const StyledCard = styled(Card)(({ theme }) => ({
  width: '100%',
  boxSizing: 'border-box',
}))

export const StyledWrapper = styled(Box)(({ theme, justify }) => ({
  // height: 'calc(100vh - 142px)',
  height: justify === 'center' ? '100%' : 'auto',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: justify ? justify : 'flex-start',
  alignContent: 'flex-start',
  width: '100%',
  boxSizing: 'border-box',
  // paddingTop: theme.spacing(8),
  paddingRight: theme.spacing(3),
  paddingLeft: theme.spacing(3),
  // add media query for justifying content
  '@media only screen and (max-device-height: 400px)': {
    height: 'auto',
    justifyContent: 'flex-start',
  },
}))

export const StyledChipContainer = styled(Box)(({ theme }) => ({
  boxSizing: 'border-box',
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  alignContent: 'flex-start',
  flexWrap: 'wrap',
  marginLeft: theme.spacing(-0.5),
  // height: theme?.isPWA ? 'calc(100vh - 200px)' : 'calc(100vh - 292px)',
  // overflow: 'hidden',
  // overflowY: 'auto',
  // paddingBottom: theme.spacing(2),
  // '&::-webkit-scrollbar': {
  //   display: 'none',
  // },
}))

export const StyledHeaderCardContainer = styled(Box)(({ theme }) => ({
  position: 'fixed',
  width: '100%',
  padding: theme.spacing(2),
  boxSizing: 'border-box',
  top: 0,
  left: 0,
  zIndex: 99,
}))

export const StyledChip = styled(Chip)(({ theme }) => ({
  margin: theme.spacing(0.5),
  fontSize: '1rem',
}))

export const Icon = styled(SvgIcon)(({ theme }) => ({
  display: 'inline-block',
  width: '60px',
  height: '65px',
  marginRight: theme.spacing(3),
  maskRepeat: 'no-repeat',
  maskSize: 'contain',
  objectFit: 'contain',
  color: theme.palette.primary.main,
  backgroundColor: theme.palette.primary.main,
}))

export const StyledPageContainer = styled(Container)(({ theme }) => ({
  '&.MuiContainer-root': {
    height: '100%',
  },
}))

export const StyledStickyContainer = styled(Box)(({ theme }) => ({
  top: 0,
  left: 0,
  zIndex: 9,
  width: '600px',
  position: 'sticky',
  padding: `8px 40px`,
  backgroundColor: theme.palette.background.default,
  boxSizing: 'border-box',

  '@media only screen and (max-device-width: 600px)': {
    width: 'calc(100vw - 0px)',
  },
}))
